module.exports = __webpack_public_path__ + "src/assets/img/-2.3119b8f6.svg";